module.exports = __webpack_public_path__ + "static/media/Philadelphia.80e1b559.jpg";